import { render } from "./FooterElem.vue?vue&type=template&id=1c9d8b3e"
import script from "./FooterElem.vue?vue&type=script&lang=js"
export * from "./FooterElem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__